import React, { useRef, useEffect, useState } from 'react';
import {IoNotificationsSharp, IoSettingsSharp, IoPerson} from 'react-icons/io5';
// import LogoutConfirmationModal from './logoutConfirmationModal'; // Add this later
// import { sendRequest } from '../../supplementary_components/requests';
import { addPopup, addNotification } from '../../supplementary_components/store';
import { ConfirmationDialogue } from '../forms/ConfirmationDialogue';
import { API_ROOT, sendRequest } from '../../supplementary_components/requests';
import { can } from '../../supplementary_components/userDataDelegate';
import { MdAccountBox } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import { IoLogOutOutline } from "react-icons/io5";
import { IosToggle } from '../content_management/reusableItems/iosToggle';
import styles from './header.module.scss';

export const HeaderButtonSet = () => {
    const [openDropdown, setOpenDropdown] = useState(null); // 'account' | 'settings' | null
    const darkModeState = JSON.parse(localStorage.getItem("darkMode"));    
    const [darkMode, setDarkMode] = useState(darkModeState !== null && darkModeState !== undefined ? darkModeState  : false);
    const containerRef = useRef(null);
    
    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpenDropdown(null);
            }
        };
        
        if (openDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDropdown]);
    
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown(prev => prev === dropdownName ? null : dropdownName);
    };
    return (
        <div className={styles.buttonsContainer} ref={containerRef}>
            <div className={styles.iconButton}>
                <IoNotificationsSharp color="var(--light-gray)" />
            </div>
            <div className={styles.dropdownWrapper}>
                <div className={`${styles.iconButton} ${openDropdown === 'settings' ? styles.iconButtonActive : ''}`} onClick={() => toggleDropdown('settings')}>
                    <IoSettingsSharp color="var(--gray)" />
                </div>
                <div className={`${styles.dropdown} ${openDropdown === 'settings' ? styles.open : ''}`}>
                    <div className={styles.dropdownItem}>
                        Settings
                    </div>
                    <hr />
                    <div className={styles.dropdownItem}>
                        Dark Mode
                        <IosToggle state={darkMode} onChangeAction={(checked)=>{
                            document.documentElement.setAttribute('data-theme', checked ? "dark" : "light");
                            setDarkMode(checked);
                            localStorage.setItem("darkMode", JSON.stringify(checked));
                        }} />
                    </div>
                </div>
            </div>
            <div className={styles.dropdownWrapper}>
                <div className={`${styles.iconButton} ${openDropdown === 'account' ? styles.iconButtonActive : ''}`} onClick={() => toggleDropdown('account')}>
                    <IoPerson color="var(--gray)" />
                </div>
                <div className={`${styles.dropdown} ${openDropdown === 'account' ? styles.open : ''}`}>
                    <div className={styles.accountName}>Current User: <span>{localStorage.getItem('currentUserFirstName')}</span></div>
                    <hr />
                    <div className={styles.dropdownItem} onClick={()=>{
                        window.location.href = document.location.origin + "/myAccount";
                    }} >My Account <MdAccountBox /></div>
                    {can('COMPANY_SETTINGS', 'VIEW') ? <div className={styles.dropdownItem} onClick={()=>{
                        window.location.href = document.location.origin + "/companySettings";
                    }} >Company Settings <IoMdSettings /></div> : null}
                    <div className={styles.dropdownItem} onClick={(e)=>{
                        addPopup({
                            content: ConfirmationDialogue,
                            popupData: {
                                action:(postResultAction)=>{
                                    const token = localStorage.getItem('access_token');
                                    sendRequest("POST", API_ROOT+"logout", null, ()=>{
                                        localStorage.removeItem('access_token');
                                        localStorage.removeItem('refresh_token');
                                        localStorage.removeItem("department");
                                        localStorage.removeItem("currentUserDispatches");
                                        postResultAction(true);
                                        window.location.href = '/login';
                                    }, ()=>{
                                        postResultAction(false);
                                        addNotification({message:"Something Went Wrong",type:'alert'});
                                    }, null, {
                                        'Authorization': `Bearer ${token}`,
                                        'Content-Type': 'application/json',
                                    });
                                },
                                name:"Confirm",
                                formTitle:"Logging out",
                                submitTitle:"Logout",
                                message:"Are you sure you want to logout?"
                            }, 
                            postSuccessAction: ()=>{
                            }, 
                            EZCloseAllowed:true
                        })
                    }}>Logout <IoLogOutOutline /></div>
                </div>
            </div>
        </div>
    );
};